import React from "react";
import { Switch } from "@fluentui/react-components";
import CustomInput from "../input/customInput/CustomInput";

const CheckboxInputStateSave = (props) => {
  const {
    label,
    customName,
    checked,
    onChange,
    onLabelChange,
    onSaveChanges = null,
    isColumnConfig = false,
    type = null,
    parentType = null,
    tableName = null,
  } = props;

  const getCheckStatus = () => {
    if (parentType === "Client") {
      if (tableName === "Client-Portfolio" && label === "Portfolio")
        return false;
      if (tableName === "Client-Program" && label === "Program") return false;
      if (tableName === "Client-Project" && label === "Project") return false;
      if (tableName === "Client-Communication Plan" && label === "Title")
        return false;
      return label === "Client" ? false : true;
    }

    if (parentType === "Portfolio") {
      if (tableName === "Portfolio-Program" && label === "Program")
        return false;
      if (tableName === "Portfolio-Project" && label === "Project")
        return false;
      if (tableName === "Portfolio-Scope" && label === "Scope") return false;
      if (tableName === "Portfolio-Change Request" && label === "Title")
        return false;
      if (tableName === "Portfolio-Risk" && label === "Name") return false;
      if (tableName === "Portfolio-Communication Plan" && label === "Title")
        return false;
      if (tableName === "Portfolio-Budget" && label === "Category")
        return false;

      return label === "Portfolio" ? false : true;
    }

    if (parentType === "Program") {
      if (tableName === "Program-Project" && label === "Project") return false;
      if (tableName === "Program-Scope" && label === "Scope") return false;
      if (tableName === "Program-Change Request" && label === "Title")
        return false;
      if (tableName === "Program-Risk" && label === "Name") return false;
      if (tableName === "Program-Communication Plan" && label === "Title")
        return false;
      if (tableName === "ProgramBudget" && label === "Project") return false;
      if (tableName === "Program-Decision" && label === "Decision") return false;

      return label === "Program" ? false : true;
    }

    if (parentType === "Project") {
      if (tableName === "Project-Scope" && label === "Scope") return false;
      if (tableName === "Project-Change Request" && label === "Title")
        return false;
      if (tableName === "Project-Risk" && label === "Name") return false;
      if (tableName === "Project-Communication Plan" && label === "Title")
        return false;
      if (tableName === "Project-Budget" && label === "Category") return false;
      if (tableName === "Project-Decision" && label === "Decision") return false;
      if (tableName === "Allocated Resources" && label === "Name") return false;
      if (tableName === "Project-Budget-Category" && label === "Payment Code") return false;
      if (tableName === "PurchaseOrders" && label === "Vendor") return false;
      if (tableName === "InvoiceRegistry" && label === "Supplier Name") return false;
      return label === "Project" ? false : true;
    }

    if (tableName === "Allocated Resources") {
      return label === "Name" ? false : true;
    }

    if (type === "Role") {
      return label === "Name" ? false : true;
    } else if (parentType === "Resource") {
      return label === "Name" ? false : label === "Shift Name" ? false : true;
    } else if (type === "Shift") {
      return label === "Shift Name" ? false : true;
    } else if (type === "Portfolio") {
      return label === "Portfolio" ? false : true;
    } else if (type === "Program") {
      return label === "Program" ? false : true;
    } else if (type === "Project") {
      return label === "Project" ? false : true;
    } else if (type === "Change Request") {
      return label === "Title" ? false : true;
    } else if (type === "Risk") {
      return label === "Name" ? false : true;
    } else if (type === "Communication Plan") {
      return label === "Title" ? false : true;
    } else if (type === "Budget") {
      return label === "Category" ? false : true;
    } else if (type === "MeetingRegistry") {
      return label === "Meeting Minutes" ? false : true;
    } else if (type === "Tasks") {
      return label === "Task" ? false : true;
    } else if (type === "Decision") {
      return label === "Decision" ? false : true;
    } else {
      return true;
    }
  };

  return (
    <div className="d-flex align-items-center gap-1">
      <div className="d-flex align-items-center">
        <div className="w-[200px] truncate">
          {isColumnConfig && getCheckStatus(label, checked) ? (
            <Switch
              className="checkboxWrapper"
              checked={checked}
              onChange={(e) =>
                getCheckStatus(label, checked) ? onChange(e) : null
              }
              label={label}
            />
          ) : !isColumnConfig ? (
            <Switch
              className="checkboxWrapper"
              checked={checked}
              onChange={onChange}
              label={label}
            />
          ) : (
            <p className="ml-14 pl-1">{label}</p>
          )}
        </div>
      </div>
      {isColumnConfig && (
        <CustomInput
          type="text"
          defaultValue={customName}
          className="border border-gray-50 bg-[#f5f5f5] p-2 w-[200px]"
          // onChange={(e) => onLabelChange(e.target.value)}
          onKeyDown={(e) =>
            e.key === "Enter" && onSaveChanges && onSaveChanges()
          }
          handleBlur={() => onSaveChanges && onSaveChanges()}
          icon={false}
          value={customName}
          handleChange={(value) => {
            onLabelChange(value);
          }}
        />
      )}
    </div>
  );
};

export default CheckboxInputStateSave;
